import appConfig from "@/app.config";

const schema = {
  tabs: [
    {
      title: 'Alerts',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Alerts",
      activeBtn: true,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: 'Add New Page',
      formData: {},
      schema: {
      name: {
        type: 'text',
        label: 'Page Title',
        placeholder: 'Enter Page Title',
        required: true,
        info: false,
        character_count: 50
        },
      },
      side_panel: {
        select_a_page: {
          type: 'list',
          label: 'Select a Topic',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: []
        }
      },
      form: {
        title: {
            type: 'text',
            label: 'Alert Title',
            placeholder: 'Enter Alert Title',
            required: true,
            info: true,
            character_count: 250,
            disabled: false,
            wrapper_class: ''
          },
        // path: {
        //   type: 'text',
        //   label: 'Path',
        //   placeholder: 'Enter Path',
        //   required: true,
        //   info: true,
        //   character_count: 50,
        //   disabled: false,
        //   wrapper_class: ''
        // },
        color: {
          type: 'select',
          label: 'Colour',
          placeholder: 'Select Colour',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: ['Red','Amber','Green']
        },
        description: {
          type: 'ckeditor',
          label: 'Description',
          placeholder: 'Enter Description',
          required: true,
          info: true,
          character_count: 2000,
          disabled: false,
          wrapper_class: ''
        },
        further_details: {
          type: 'radio',
          label: 'Further Details',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [
            {
              name: 'News Item',
            },
            {
              name: 'External Link',
            }
          ]
        },
        news_item: {
          type: 'select',
          label: 'Select News Item',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: []
        },
        external_link: {
          type: 'text',
          label: 'Enter Link Here',
          placeholder: 'Enter / Paste Link Here',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: []
        },
      }
    }
  ]
};

export { schema };